import React from "react";
import { makeStyles } from "@material-ui/core";
import { fontConfig } from "theme/fontConfig";

export const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 500,
    padding: theme.spacing(2),
  },
  avatar: {
    width: 110,
    height: 110,
    margin: "0 auto",
    fontSize: 35,
  },
  userName: {
    textAlign: "center",
    color: "#002E5C",
    fontFamily: fontConfig.MemberDetailsUserNameFont.family,
    fontSize: 24,
    fontStyle: "normal",
    fontWeight: 600,
    marginTop: theme.spacing(1),
  },
  userId: {
    textAlign: "center",
    color: "#002E5C",
    fontFamily: fontConfig.MemberDetailsUserIdFont.family,
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    textTransform: "capitalize",
    mb: 2,
  },
  contactButtons: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  progressContainer: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
  eventCard: {
    background: "#F3F7FF",
    padding: theme.spacing(2),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    height: 60,
  },
  pastEventCard: {
    background: "#E4FFE7",
    padding: theme.spacing(2),
    borderRadius: 8,
    marginBottom: theme.spacing(2),
  },
  eventTitle: {
    fontWeight: 600,
  },
  contactWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "1.5rem",
    marginBottom: "1rem",
  },
  contactBtn: {
    backgroundColor: "#D3DDFC",
    height: 39,
    width: "100%",
    cursor: "pointer",
    border: "none",
    color: "#2555EF",
    padding: "0 10px",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    fontWeight: 500,
    fontFamily: fontConfig.MemberDetailsContactBtnFont.family,
    fontSize: 14,
    "&:hover": {
      opacity: 0.9,
    },
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  icon: {
    height: 12,
    marginRight: 4,
  },
  btnMargin: {
    marginLeft: 4,
    marginRight: 4,
  },
  container: {
    backgroundColor: "#F3F6F9",
    borderRadius: 10,
    padding: theme.spacing(1),
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  chartWrapper: {
    marginRight: theme.spacing(2),
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: "#002E5C",
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 500,
    color: "#002E5C",
    opacity: 0.4,
  },
  scrollContainer: {
    overflowY: "auto",
    paddingRight: 8,
  },
  sectionTitle: {
    fontFamily: fontConfig.MemberDetailsSectionTitleFont.family,
    fontSize: 16,
    fontWeight: 600,
    textTransform: "capitalize",
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    color: "#002E5C",
    opacity: 0.9,
  },
  badge: {
    backgroundColor: "#0D2451",
    color: "#fff",
    borderRadius: "50%",
    fontSize: 10,
    width: 20,
    height: 20,
    textAlign: "center",
    lineHeight: "20px",
    marginLeft: 8,
    opacity: 0.9,
  },
  archivedBtn: {
    marginLeft: "auto",
    background: "#F3F6F9",
    padding: "4px 10px",
    height: 23,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.9,
    },
  },
  card: {
    borderRadius: 10,
    padding: 16,
    marginBottom: 12,
    position: "relative",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.06)",
    backgroundColor: "#fff",
    marginTop: 8,
  },
  title: {
    fontFamily: fontConfig.MemberDetailsTitleFont.family,
    fontSize: 15,
    fontWeight: 600,
    textTransform: "capitalize",
  },
  description: {
    fontFamily: fontConfig.MemberDetailsDescriptionFont.family,
    fontSize: 14,
    fontWeight: 400,
    textTransform: "capitalize",
    marginTop: 4,
    color: "#555",
  },
  date: {
    fontSize: 12,
    fontWeight: 400,
    position: "absolute",
    top: 16,
    right: 40,
    color: "#B5B5C3",
  },
  dotButton: {
    position: "absolute",
    top: 13,
    right: 8,
  },
  delayTag: {
    borderRadius: 6,
    padding: "4px 10px",
    fontSize: 12,
    color: "#1F9254",
    fontWeight: 500,
    alignItems: "center",
    marginTop: 8,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 28,
  },
  updateText: {
    fontSize: 12,
    fontFamily: fontConfig.MemberDetailsUpdateTextFont.family,
    marginTop: 10,
    marginBottom: 5,
    color: "#002E5C",
    opacity: 0.7,
  },
  updateDes: {
    fontSize: 15,
    fontFamily: fontConfig.MemberDetailsUpdateDesFont.family,
    marginBottom: 5,
    color: "#002E5C",
    opacity: 0.8,
  },
  updatedInfo: {
    display: "flex",
    alignItems: "center",
    marginTop: 6,
  },
  updateTime: {
    fontSize: 11,
    color: "#A8A8B5",
    marginLeft: 8,
  },
  eventCardStyle: {
    maxHeight: 300,
    overflowY: "auto",
    paddingBottom: "30px",
    borderRadius: 10,
  },
}));
